/* Atomic Bear — Stealth Pen Pro offer page interactions */
(function () {
  'use strict';

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {
    var root = document.getElementById('atb-lp');
    if (!root) return;

    /* ---------- Countdown ---------- */
    (function () {
      var el = document.getElementById('atb-countdown');
      if (!el) return;
      var dur = (2 * 3600 + 6 * 60 + 18) * 1000;
      var KEY = 'atb_cd_end_v1';
      var end = parseInt(localStorage.getItem(KEY), 10);
      if (!end || end < Date.now()) { end = Date.now() + dur; localStorage.setItem(KEY, end); }
      var h = el.querySelector('[data-cd="h"]');
      var m = el.querySelector('[data-cd="m"]');
      var s = el.querySelector('[data-cd="s"]');
      function pad(n) { return (n < 10 ? '0' : '') + n; }
      function tick() {
        var diff = end - Date.now();
        if (diff <= 0) { end = Date.now() + dur; localStorage.setItem(KEY, end); diff = dur; }
        var hh = Math.floor(diff / 3600000);
        var mm = Math.floor((diff % 3600000) / 60000);
        var ss = Math.floor((diff % 60000) / 1000);
        if (h) h.textContent = pad(hh);
        if (m) m.textContent = pad(mm);
        if (s) s.textContent = pad(ss);
      }
      tick();
      setInterval(tick, 1000);
    })();

    /* ---------- Gallery ---------- */
    (function () {
      var main = document.getElementById('atb-gallery-main');
      var thumbs = document.getElementById('atb-thumbs');
      if (!main || !thumbs) return;
      thumbs.addEventListener('click', function (e) {
        var btn = e.target.closest('.atb-thumb');
        if (!btn) return;
        var img = btn.querySelector('img');
        if (img) main.src = img.getAttribute('data-full') || img.src;
        thumbs.querySelectorAll('.atb-thumb').forEach(function (t) { t.classList.remove('is-active'); });
        btn.classList.add('is-active');
      });
      
      function goTo(i) {
        var list = Array.prototype.slice.call(thumbs.querySelectorAll('.atb-thumb'));
        if (!list.length) return;
        i = (i + list.length) % list.length;
        var btn = list[i];
        var img = btn.querySelector('img');
        if (img) main.src = img.getAttribute('data-full') || img.src;
        list.forEach(function (t) { t.classList.remove('is-active'); });
        btn.classList.add('is-active');
        btn.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'smooth' });
      }
      
      var swX = 0, swY = 0;
      main.addEventListener('touchstart', function (e) { swX = e.touches[0].clientX; swY = e.touches[0].clientY; }, { passive: true });
      main.addEventListener('touchend', function (e) {
        var dx = e.changedTouches[0].clientX - swX, dy = e.changedTouches[0].clientY - swY;
        if (Math.abs(dx) < 40 || Math.abs(dx) < Math.abs(dy)) return;
        var list = Array.prototype.slice.call(thumbs.querySelectorAll('.atb-thumb'));
        var cur = list.indexOf(thumbs.querySelector('.atb-thumb.is-active'));
        goTo(dx < 0 ? cur + 1 : cur - 1);
      }, { passive: true });
      
      var wrap = thumbs.closest('.atb-gallery__thumbwrap');
      if (wrap) {
        var prevBtn = wrap.querySelector('.atb-thumb-nav--prev');
        var nextBtn = wrap.querySelector('.atb-thumb-nav--next');
        function syncNav() {
          var sl = thumbs.scrollLeft, max = thumbs.scrollWidth - thumbs.clientWidth, has = max > 2;
          if (prevBtn) prevBtn.hidden = !has || sl <= 2;
          if (nextBtn) nextBtn.hidden = !has || sl >= max - 2;
        }
        if (prevBtn) prevBtn.addEventListener('click', function () { thumbs.scrollBy({ left: -thumbs.clientWidth * 0.8, behavior: 'smooth' }); });
        if (nextBtn) nextBtn.addEventListener('click', function () { thumbs.scrollBy({ left: thumbs.clientWidth * 0.8, behavior: 'smooth' }); });
        thumbs.addEventListener('scroll', syncNav, { passive: true });
        window.addEventListener('resize', syncNav);
        syncNav();
      }
    })();

    /* ---------- Bundle selector ---------- */
    var selectedQty = 1;
    var selectedDiscount = '';

    (function () {
      var wrap = document.getElementById('atb-bundles');
      if (!wrap) return;

      var nameEl  = document.getElementById('atb-bundle-name');
      var pppEl   = document.getElementById('atb-bundle-ppp');
      var nowEl   = document.getElementById('atb-price-now');
      var wasEl   = document.getElementById('atb-price-was');
      var badgeEl = document.getElementById('atb-price-badge');
      var atcBtn  = document.getElementById('atb-atc');
      var gifts   = document.querySelectorAll('.atb-gift[data-gift-min]');
      var notes   = document.querySelectorAll('.atb-atc__note[data-qty]');

      function select(btn) {
        wrap.querySelectorAll('.atb-bundle').forEach(function (b) {
          b.classList.remove('is-active');
        });
        btn.classList.add('is-active');
        selectedQty = parseInt(btn.getAttribute('data-qty'), 10) || 1;
        selectedDiscount = btn.getAttribute('data-discount') || '';

        notes.forEach(function (note) {
          var noteQty = parseInt(note.getAttribute('data-qty'), 10) || 1;
          if (noteQty === selectedQty) {
            note.classList.add('active');
          } else {
            note.classList.remove('active');
          }
        });

        gifts.forEach(function (g) {
          var giftMin = parseInt(g.getAttribute('data-gift-min'), 10) || 1;
          g.classList.toggle('is-locked', selectedQty < giftMin);
        });

        if (nameEl) {
          nameEl.textContent = btn.getAttribute('data-name');
        }

        if (pppEl) {
          pppEl.textContent = btn.getAttribute('data-ppp');
        }

        var now   = btn.getAttribute('data-now');
        var was   = btn.getAttribute('data-was');
        var badge = btn.getAttribute('data-badge');

        if (nowEl && now) {
          nowEl.textContent = now;
        }

        if (wasEl) {
          wasEl.textContent = was || ' ';
          wasEl.style.visibility = was ? 'visible' : 'hidden';
        }

        if (badgeEl) {
          badgeEl.textContent = badge || ' ';
          badgeEl.style.visibility = badge ? 'visible' : 'hidden';
        }

        if (atcBtn && now) {
          var compHtml = was ? '<span>' + was + '</span>' : '';
          var label = atcBtn.getAttribute('data-label') || 'ADD TO CART';
          atcBtn.innerHTML = label + ' • ' + now + compHtml;
        }

        var variantId = btn.getAttribute('data-variant');
        if (atcBtn && variantId) {
          atcBtn.setAttribute('data-variant', variantId);
        }
      }

      wrap.addEventListener('click', function (e) {
        var btn = e.target.closest('.atb-bundle');
        if (btn) {
          select(btn);
        }
      });

      var initial = wrap.querySelector('.atb-bundle.is-active') ||
                    wrap.querySelector('.atb-bundle[data-qty="3"]') ||
                    wrap.querySelector('.atb-bundle');
      if (initial) {
        select(initial);
      }
    })();

    /* ---------- Accordions (product + faq) ---------- */
    root.querySelectorAll('.atb-acc').forEach(function (acc) {
      acc.addEventListener('click', function (e) {
        var head = e.target.closest('.atb-acc__head');
        if (!head) return;
        var item = head.closest('.atb-acc__item');
        if (item) item.classList.toggle('is-open');
      });
    });
    
    if (window.matchMedia('(max-width: 900px)').matches) {
      var featOpen = root.querySelector('.atb-acc__item[data-open-mobile]');
      if (featOpen) featOpen.classList.add('is-open');
    }

    /* ---------- Testimonial carousel ---------- */
    (function () {
      var track = document.getElementById('atb-testi-track');
      var dotsWrap = document.getElementById('atb-testi-dots');
      if (!track) return;
      var slides = track.children.length;
      var i = 0;
      var dots = dotsWrap ? Array.prototype.slice.call(dotsWrap.children) : [];
      
      function go(n) {
        i = (n + slides) % slides;
        track.style.transform = 'translateX(' + (-i * 100) + '%)';
        dots.forEach(function (d, k) { d.classList.toggle('is-active', k === i); });
      }
      
      root.querySelectorAll('[data-testi]').forEach(function (b) {
        b.addEventListener('click', function () { go(b.getAttribute('data-testi') === 'next' ? i + 1 : i - 1); });
      });
      
      dots.forEach(function (d, k) { d.addEventListener('click', function () { go(k); }); });
      go(0);
    })();

    /* ---------- Second Testimonial carousel ---------- */
    (function () {
      var track = document.getElementById('atb-testi-trackk');
      var dotsWrap = document.getElementById('atb-testi-dotss');
      if (!track) return;
      var slides = track.children.length;
      var i = 0;
      var dots = dotsWrap ? Array.prototype.slice.call(dotsWrap.children) : [];
      
      function go(n) {
        i = (n + slides) % slides;
        track.style.transform = 'translateX(' + (-i * 100) + '%)';
        dots.forEach(function (d, k) { d.classList.toggle('is-active', k === i); });
      }
      
      root.querySelectorAll('[data-testii]').forEach(function (b) {
        b.addEventListener('click', function () { go(b.getAttribute('data-testii') === 'next' ? i + 1 : i - 1); });
      });
      
      dots.forEach(function (d, k) { d.addEventListener('click', function () { go(k); }); });
      go(0);
    })();

    /* ---------- Comparison carousel (mobile, swipe + dots) ---------- */
    (function () {
      var track = document.getElementById('atb-ctrack');
      var dotsWrap = document.getElementById('atb-cdots');
      if (!track || !dotsWrap) return;
      var dots = Array.prototype.slice.call(dotsWrap.children);
      var n = track.children.length;
      
      function update() {
        var i = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
        i = Math.max(0, Math.min(n - 1, i));
        dots.forEach(function (d, k) { d.classList.toggle('is-active', k === i); });
      }
      
      track.addEventListener('scroll', update, { passive: true });
      dots.forEach(function (d, k) { d.addEventListener('click', function () { track.scrollTo({ left: k * track.clientWidth, behavior: 'smooth' }); }); });
      update();
    })();

    /* ---------- Trouble-section videos: play in view, pause off-screen ---------- */
    (function () {
      var vids = document.querySelectorAll('.atb-tcol__vid');
      if (!vids.length) return;
      if (!('IntersectionObserver' in window)) { 
        vids.forEach(function (v) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }); 
        return; 
      }
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          var v = e.target;
          if (e.isIntersecting) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
          else { v.pause(); }
        });
      }, { threshold: 0.2 });
      vids.forEach(function (v) { io.observe(v); });
    })();

    /* ---------- Show more reviews ---------- */
    (function () {
      var btn = document.querySelector('.atb-reviews__more button');
      var grid = document.getElementById('atb-masonry');
      if (!btn || !grid) return;
      var expanded = false;
      btn.addEventListener('click', function () {
        if (expanded) return;
        var clone = grid.cloneNode(true);
        Array.prototype.forEach.call(clone.children, function (c) { grid.appendChild(c.cloneNode(true)); });
        expanded = true;
        btn.style.display = 'none';
      });
    })();

    /* ---------- Add to cart ---------- */
    function addToCart(variantId, qty, button) {
      if (!variantId) { 
        if (button) button.classList.remove('is-loading');
        updateAndOpenOCUCart();
        return;
      }
      
      if (button) button.classList.add('is-loading');
      
      var items = [{ id: Number(variantId), quantity: qty || 1 }];
      
      // Include unlocked free gifts
      document.querySelectorAll('.atb-gift[data-gift-min][data-variant]:not(.is-locked)').forEach(function (g) {
        items.push({ id: Number(g.getAttribute('data-variant')), quantity: 1 });
      });
      
      // Clear cart first
      fetch('/cart/clear.js', { method: 'POST' })
        .catch(function () {})
        .then(function () {
          // Add items to cart
          return fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ items: items })
          });
        })
        .then(function (res) {
          // For 1-pack, apply discount code
          if (qty === 1) {
            // Try to apply discount - don't wait for response
            fetch('/cart.js')
              .then(function (r) { return r.json(); })
              .then(function (cart) {
                fetch('/cart/update.js', {
                  method: 'POST',
                  headers: { 'Content-Type': 'application/json' },
                  body: JSON.stringify({ discount: '1FOR39.99' })
                }).catch(function () {});
              })
              .catch(function () {});
          }
          
          // Always remove loading and open cart drawer
          if (button) button.classList.remove('is-loading');
          updateAndOpenOCUCart();
        })
        .catch(function (err) {
          console.error('Add to cart error:', err);
          if (button) button.classList.remove('is-loading');
          updateAndOpenOCUCart();
        });
    }
    
    /* ---------- Order now: cart permalink straight to checkout ----------
       Builds /cart/PEN:QTY[,GIFT:1...]?channel=...&discount=CODE
       Gifts = every .atb-gift that is currently unlocked for the selected bundle.
       No AddToCart event is fired (same as the GemPages Buy Now page). */
    function buildCheckoutUrl(variantId, qty, discount, channel) {
      var lines = [Number(variantId) + ':' + (qty || 1)];
      document.querySelectorAll('.atb-gift[data-gift-min][data-variant]:not(.is-locked)').forEach(function (g) {
        lines.push(Number(g.getAttribute('data-variant')) + ':1');
      });
      var params = [];
      if (channel) params.push('channel=' + encodeURIComponent(channel));
      if (discount) {
        params.push('discount=' + discount.split(',').map(function (c) {
          return encodeURIComponent(c.trim());
        }).join(','));
      }
      return '/cart/' + lines.join(',') + (params.length ? '?' + params.join('&') : '');
    }

    function goToCheckout(variantId, qty, discount, button) {
      if (!variantId) return;
      if (button) button.classList.add('is-loading');
      window.location.href = buildCheckoutUrl(variantId, qty, discount, button && button.getAttribute('data-channel'));
    }

    var atc = document.getElementById('atb-atc');
    if (atc) {
      atc.addEventListener('click', function () {
        if (atc.getAttribute('data-mode') === 'checkout') {
          goToCheckout(atc.getAttribute('data-variant'), selectedQty, selectedDiscount, atc);
        } else {
          addToCart(atc.getAttribute('data-variant'), selectedQty, atc);
        }
      });
    }
    
    // Reset loading state on page restore
    window.addEventListener('pageshow', function () { 
      if (atc) atc.classList.remove('is-loading'); 
    });

    /* ---------- Smooth-scroll triggers ---------- */
    document.querySelectorAll('[data-scrollto]').forEach(function (el) {
      function go(e) { 
        var t = document.querySelector(el.getAttribute('data-scrollto')); 
        if (t) { 
          if (e) e.preventDefault(); 
          t.scrollIntoView({ behavior: 'smooth', block: 'start' }); 
        } 
      }
      el.addEventListener('click', go);
      el.addEventListener('keydown', function (e) { 
        if (e.key === 'Enter' || e.key === ' ') { 
          e.preventDefault(); 
          go(e); 
        } 
      });
    });
  });


/* ============================================================
   OCU Cart — Full Code (Final)
   ============================================================ */

/* ---------- Body Scroll Lock ---------- */
var ocuScrollY = 0;

function lockBodyScroll() {
  ocuScrollY = window.scrollY;
  document.documentElement.style.overflow = 'hidden';
  document.body.style.overflow = 'hidden';
  document.body.style.position = 'fixed';
  document.body.style.top = '-' + ocuScrollY + 'px';
  document.body.style.width = '100%';
}

function unlockBodyScroll() {
  document.documentElement.style.overflow = '';
  document.body.style.overflow = '';
  document.body.style.position = '';
  document.body.style.top = '';
  document.body.style.width = '';
  window.scrollTo(0, ocuScrollY);
}

/* ---------- Cart Update + Open ---------- */
function updateAndOpenOCUCart() {
  window.dispatchEvent(new Event('focus'));
  document.dispatchEvent(new Event('visibilitychange'));
  document.dispatchEvent(new CustomEvent('cart:updated'));
  document.dispatchEvent(new CustomEvent('cart:refresh'));
  window.dispatchEvent(new CustomEvent('ocu:cart:refresh'));

  setTimeout(function () {
    var cartDrawer = document.querySelector('.ocu-cart-drawer');
    if (cartDrawer) {
      cartDrawer.classList.add('ocu-visible');
    }

    var overlay = document.querySelector('.ocu-cart-overlay');
    if (!overlay) {
      overlay = document.createElement('div');
      overlay.className = 'ocu-cart-overlay';
      overlay.setAttribute('data-v-6a289f2a', '');
      overlay.setAttribute('data-v-2db2e31e', '');
      overlay.setAttribute('data-ocu-custom', 'true');
      document.body.appendChild(overlay);
      overlay.addEventListener('click', closeOCUCart);
    }
    overlay.classList.add('ocu-visible');

    document.body.classList.add('ocu-cart-open');
    lockBodyScroll();
  }, 300);
}

/* ---------- Cart Close ---------- */
function closeOCUCart() {
  var cartDrawer = document.querySelector('.ocu-cart-drawer');
  if (cartDrawer) {
    cartDrawer.classList.remove('ocu-visible');
  }

  var overlay = document.querySelector('.ocu-cart-overlay');
  if (overlay) {
    overlay.classList.remove('ocu-visible');
    if (overlay.hasAttribute('data-ocu-custom')) {
      overlay.remove();
    }
  }

  document.body.classList.remove('ocu-cart-open');
  unlockBodyScroll();
}

/* ---------- Add To Cart ---------- */
function addToOCUCart(variantId, quantity) {
  if (typeof quantity === 'undefined') {
    quantity = 1;
  }
  
  return fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: Number(variantId), quantity: quantity })
  })
  .then(function (res) {
    if (!res.ok) {
      return res.json().then(function (err) { 
        throw new Error(err.description || 'Add failed'); 
      });
    }
    return res.json();
  })
  .then(function (item) {
    updateAndOpenOCUCart();
    return item;
  })
  .catch(function (err) {
    console.error('OCU add to cart error:', err);
    alert(err.message);
  });
}

/* ---------- Event Bindings ---------- */
document.addEventListener('click', function (e) {
  var closeBtn = e.target.closest('.ocu-cart-header--close');
  if (closeBtn) {
    closeOCUCart();
    return;
  }

  var atcBtn = e.target.closest('[data-ocu-atc]');
  if (atcBtn) {
    e.preventDefault();
    var id = atcBtn.getAttribute('data-variant-id');
    var qty = parseInt(atcBtn.getAttribute('data-qty') || '1', 10);
    if (id) {
      addToOCUCart(id, qty);
    }
    return;
  }

  var cartLink = e.target.closest('a[href="/cart"], a[href^="/cart?"], [data-open-ocu-cart]');
  if (cartLink) {
    e.preventDefault();
    updateAndOpenOCUCart();
  }
});

})();